// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"75346":"321a1ec594190956","78891":"6fa6d54b551ce5e0"}[chunkId] + ".css";
};